import FiltersConstants from '@/constants/FiltersConstants';

export const getTranslatedReview = (review, t) => {
	switch (review) {
		case FiltersConstants.REVIEW_LEVELS.EXCELLENT:
			return t('Hotel.Excellent');
		case FiltersConstants.REVIEW_LEVELS.VERY_GOOD:
			return t('Hotel.VeryGood');
		case FiltersConstants.REVIEW_LEVELS.GOOD:
			return t('Hotel.Good');
		case FiltersConstants.REVIEW_LEVELS.FAIR:
			return t('Hotel.Fair');
		case FiltersConstants.REVIEW_LEVELS.POOR:
			return t('Hotel.Poor');
		default:
			return review;
	}
};
